export default __webpack_public_path__ + "static/media/voucher.8dd4a2b4.jpeg";